import { TrackInfo } from '../constants';

const tracksMatch = (n?: TrackInfo, old?: TrackInfo): boolean => {
  if (!n) {
    return true;
  }
  return n.lang === old?.lang && n.name === old?.name;
};

export default tracksMatch;
